<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19.13" height="18.901" viewBox="0 0 19.13 18.901">
    <g transform="translate(-1102.504 -581.061)">
      <path
        d="M1111.54,599.962a6.987,6.987,0,0,1-3.1-.879,9.355,9.355,0,0,1-5.919-7.841,9.764,9.764,0,0,1,7.049-9.912l.122-.022c2.253-.347,8.247-1.265,11.19,5.422,1,2.279,1.008,4.186.017,5.668-1.441,2.154-4.408,2.522-4.961,2.534-1.555-.034-2.483.136-2.792.506a.464.464,0,0,0-.08.433,5.806,5.806,0,0,0,.461,1.271,2.2,2.2,0,0,1,.307,1.773,1.683,1.683,0,0,1-1.095.857A3.628,3.628,0,0,1,1111.54,599.962Zm.874-17.9a16.52,16.52,0,0,0-2.574.238,8.754,8.754,0,0,0-6.326,8.877,8.342,8.342,0,0,0,5.314,6.989l.074.036c.021.012,2,1.154,3.505.629.4-.137.484-.259.5-.306.07-.162-.125-.588-.3-.964a6.69,6.69,0,0,1-.532-1.491,1.469,1.469,0,0,1,.294-1.272c.684-.814,2.18-.892,3.549-.863h.014a5.808,5.808,0,0,0,4.125-2.089c.79-1.18.755-2.765-.1-4.71A7.712,7.712,0,0,0,1112.414,582.058Z"
      />
      <g>
        <circle
          cx="2"
          cy="2"
          r="2"
          transform="translate(1115.068 587.504)"
          fill="#fff"
        />
        <path
          d="M1117.068,591.5a2,2,0,1,1,2-2A2,2,0,0,1,1117.068,591.5Zm0-3a1,1,0,1,0,1,1A1,1,0,0,0,1117.068,588.5Z"
        />
      </g>
      <g>
        <circle
          cx="2"
          cy="2"
          r="2"
          transform="translate(1113.068 583.504)"
          fill="#fff"
        />
        <path
          d="M1115.068,587.5a2,2,0,1,1,2-2A2,2,0,0,1,1115.068,587.5Zm0-3a1,1,0,1,0,1,1A1,1,0,0,0,1115.068,584.5Z"
        />
      </g>
      <g>
        <circle
          cx="2"
          cy="2"
          r="2"
          transform="translate(1108.068 583.504)"
          fill="#fff"
        />
        <path
          d="M1110.068,587.5a2,2,0,1,1,2-2A2,2,0,0,1,1110.068,587.5Zm0-3a1,1,0,1,0,1,1A1,1,0,0,0,1110.068,584.5Z"
        />
      </g>
      <g>
        <circle
          cx="2"
          cy="2"
          r="2"
          transform="translate(1105.068 586.504)"
          fill="#fff"
        />
        <path
          d="M1107.068,590.5a2,2,0,1,1,2-2A2,2,0,0,1,1107.068,590.5Zm0-3a1,1,0,1,0,1,1A1,1,0,0,0,1107.068,587.5Z"
        />
      </g>
    </g>
  </svg>
</template>
